import React from "react";
import { Button } from "..";
import "./getStartedCard.css";

export const GetStartedCard = ({ text = "", action = () => {} }) => {
   return (
      <div className="started-card flex-wrap">
         <p>{text}</p>
         <Button
            label="Get Started"
            onClick={() => {
               window.open(`https://platform.knight.ventures`);
            }}
         />
      </div>
   );
};
